const classMap = {
  active:    's-ac',
  overdue:   's-ov',
  available: 's-av',
  booked:    's-bk',
  complete:  's-ac',
  inactive:  's-av',
  new:       's-new',
  maintenance:'s-mt',
  paid:      's-ac',
  pending:   's-bk',
  cancelled: 's-av',
  draft:     's-mt',
};

const labelMap = {
  active:    'Active',
  overdue:   'Overdue',
  available: 'Available',
  booked:    'Booked',
  complete:  'Complete',
  inactive:  'Inactive',
  new:       'New',
  maintenance:'Maintenance',
  paid:      'Paid',
  pending:   'Pending',
  cancelled: 'Cancelled',
  draft:     'Draft',
};

export default function StatusPill({ status, label }) {
  const cls = classMap[status] || 's-av';
  const lbl = label || labelMap[status] || status;
  return <span className={`sp ${cls}`}>{lbl}</span>;
}
